
  export default {
    components: {
      FilesPreview: () => import('../components/FilesPreview'),
      RedemptionCodeModal: () => import('../components/RedemptionCodeModal.vue'),
    },
  };
